import { useState, useEffect } from "react";
import FilterSupplierProduct from "./FilterSupplierProduct";
import AddSupplierProduct from "./AddSupplierProduct";
import SupplierProductItem from "./SupplierProductItem";
import useAxios from "../../../services/useAxios";
import { debounce } from "lodash";
import "./supplier-product.scss";
import Loader from "../utils/Loader";
import Pagination from "rc-pagination";


export default function MainList() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);


  // request on product react select search
  const { loadingProduct, execute: productListApi } = useAxios(
    "supplier/get_product"
  );
  // request for supplier list in react select
  const { loadingSupplier, execute: supplierListApi } =
    useAxios("api/Find_suppliers");
  // request for supplier product list
  const { loadingList, execute: supplierProductListApi } = useAxios(
    "api/get_avb_product"
  );
  // state for product react select
  const [productList, setProductList] = useState([]);
  // state for supplier react select
  const [supplierList, setSupplierList] = useState([]);
  // state for supplier product list
  const [productSupplierList, setProductSupplierList] = useState([]);
  // state for update supplier product list
  const [updater, setUpdater] = useState(false);
  // state for filter react select
  const [filterData, setFilterData] = useState({ product: [], supplier: [] });
  // loader state
  const [loading, setLoading] = useState(true);
  // function for handler filter react select
  const filterDataHandler = (object) => {
    setFilterData((prev) => {
      return { ...prev, ...object };
    });
  };
  // function for request on search product react select
  const productListSelect = (txt,page) => {
    productListApi({
      page: page,
      count: "100",
      keyword: txt,
    }).then((result) => {
      let temp = result?.data?.map((value) => {
        return { label: value.title, value: value.products__id };
      });
      setProductList(temp);
    });
  };
  // function for filter request
  const supplierProductFilter = (productIds, supplierIds) => {
    setLoading(true);
    supplierProductListApi({
      productId: productIds,
      supplierId: supplierIds,
      page:1,count:10
     
    }).then((result) => {
      setProductSupplierList((result.items).reverse());
      setTotalPage(result.total)
      setCurrentPage(1)
      setLoading(false);
    });
  };
  // send request in time and by search
  const pageDebounce = debounce(productListSelect, 1000);
  // send request react select product and react select supplier
  useEffect(() => {
    pageDebounce("",1);
    supplierListApi().then((result) => {
      let temp = result.map((value) => {
        return { label: value.title, value: value.id };
      });
      setSupplierList(temp);
    });
  }, []);
  // send request supplier product list
  const listRequest=(object)=>{
     supplierProductListApi({ ...object,count:10}).then((result) => {
      setProductSupplierList((result.items));
      setTotalPage(result.total)
      setLoading(false);
    });
  }
  useEffect(() => {
    listRequest({page:currentPage})
  }, [updater]);
  console.log("currentPage",currentPage,totalPage)
  return loading ? (
    <Loader />
  ) : (
    <div className="supplier-product mt-3">
      <AddSupplierProduct
        productList={productList}
        supplierList={supplierList}
        pageDebounce={pageDebounce}
        setUpdater={setUpdater}
      />
      <FilterSupplierProduct
        productList={productList}
        supplierList={supplierList}
        pageDebounce={pageDebounce}
        filterData={filterData}
        filterDataHandler={filterDataHandler}
        supplierProductFilter={supplierProductFilter}
        setUpdater={setUpdater}
      />
      <h5 className="my-2">لیست محصولات فروشگاهها</h5>
      <div className="py-2">
        {productSupplierList.map((value) => {
          return <SupplierProductItem data={value} setUpdater={setUpdater} />;
        })}
      </div>
      <div className="d-flex justify-content-center mt-3 pb-2">
          <Pagination
            total={totalPage}
            pageSize={10}
            current={currentPage}
            onChange={newPage => {
              let temp={}
              if(filterData.product.length>0)temp={...temp,productId:filterData.product.map((val) => val.value)}
              if(filterData.supplier.length>0)temp={...temp,supplierId:filterData.supplier.map((val) => val.value)}

              setCurrentPage(newPage);
              listRequest({page:newPage,...temp})
            }}
          ></Pagination>
        </div>
    </div>
  );
}
